import script from "./participantsTotals.vue?vue&type=script&setup=true&lang=ts"
export * from "./participantsTotals.vue?vue&type=script&setup=true&lang=ts"

import "./participantsTotals.vue?vue&type=style&index=0&id=397b424a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-397b424a"]])

export default __exports__